import {
  ApprovalsMaterializedApprovalFlowHistoryDocument,
  BulkApproveMaterializedApprovalsFlowDocument,
  BulkApproveMaterializedApprovalsFlowMutationVariables,
  BulkRejectMaterializedApprovalsFlowDocument,
  BulkRejectMaterializedApprovalsFlowMutationVariables,
  GetMaterializedApprovalsFlowsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useMaterializedApprovalFlowHistory = (resourceId: string, resourceType: string) => {
  const { data, loading } = useQuery(ApprovalsMaterializedApprovalFlowHistoryDocument, {
    variables: { resourceType, resourceIds: [resourceId] },
    fetchPolicy: 'network-only',
  })

  const materializedApprovalFlow = data?.approvals.materializedApprovalsFlowsConnection.nodes[0]

  return {
    loading,
    materializedApprovalFlow,
  }
}

const optimisticResponse = {
  __typename: 'root_mutation' as const,
  approvalsMutations: {
    __typename: 'approvalsMutations' as const,
    bulkApproveApprovalsMaterializedApprovalsFlow: {
      __typename: 'BulkApproveApprovalsMaterializedApprovalsFlowPayload' as const,
      errors: [],
    },
  },
}

export const useBulkApproveMaterializedApprovalFlow = () => {
  const [bulkApproveFlow, { loading }] = useMutation(BulkApproveMaterializedApprovalsFlowDocument, {
    extractorFn: (data) => data.approvalsMutations.bulkApproveApprovalsMaterializedApprovalsFlow,
    optimisticResponse,
  })

  return {
    loading,
    bulkApproveMaterializedFlow(
      variables: BulkApproveMaterializedApprovalsFlowMutationVariables,
      companyId: string
    ) {
      return bulkApproveFlow({
        variables,
        refetchQueries: [
          {
            query: GetMaterializedApprovalsFlowsDocument,
            variables: {
              ids: variables.materializedApprovalFlowIds,
              companyId,
            },
          },
        ],
      })
    },
  }
}

export const useBulkRejectMaterializedApprovalFlow = () => {
  const [bulkRejectFlow, { loading }] = useMutation(BulkRejectMaterializedApprovalsFlowDocument, {
    extractorFn: (data) => data.approvalsMutations.bulkRejectApprovalsMaterializedApprovalsFlow,
  })

  return {
    loading,
    bulkRejectMaterializedFlow(
      variables: BulkRejectMaterializedApprovalsFlowMutationVariables,
      companyId: string
    ) {
      return bulkRejectFlow({
        variables,
        refetchQueries: [
          {
            query: GetMaterializedApprovalsFlowsDocument,
            variables: {
              ids: variables.materializedApprovalFlowIds,
              companyId,
            },
          },
        ],
      })
    },
  }
}
